import React from 'react'
import SvgIcon, { SvgIconProps } from 'components/Luxkit/SvgIcon'

function LineWeightIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M19 4h-1.45A3.0798 3.0798 0 0 0 17 3a3 3 0 0 0-2.25-1H9.27A2.9998 2.9998 0 0 0 7 3a3.08 3.08 0 0 0-.57 1H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3Zm-10.48.34A1 1 0 0 1 9.27 4h5.46a.9998.9998 0 0 1 .75.34.9996.9996 0 0 1 .25.78l-.5 4a1.0002 1.0002 0 0 1-1 .88h-1.64l1.14-2.4a1.0002 1.0002 0 0 0-.4997-1.268 1 1 0 0 0-1.3003.408L10.37 10h-.6a1.0001 1.0001 0 0 1-1-.88l-.5-4a1 1 0 0 1 .25-.78ZM20 19a1.0003 1.0003 0 0 1-1 1H5a1.0002 1.0002 0 0 1-1-1V7a1 1 0 0 1 1-1h1.37l.42 3.37a3 3 0 0 0 3 2.6299h4.46a3 3 0 0 0 3-2.63L17.63 6H19a1 1 0 0 1 1 1v12Zm-6-3.0001h-4A1.0002 1.0002 0 0 0 10 18h4a1.0001 1.0001 0 0 0 0-2.0001Z"/>
  </SvgIcon>
}

export default LineWeightIcon
